import { AppDrawer } from "@/components/layout/elements/AppDrawer";
import { AppHeader } from "@/components/layout/elements/AppHeader";
import { SocketProvider } from "@/providers/SocketProvider";
import { withAuth } from "@/hoc/withAuth";
import { useVisible } from "@/hooks/useVisible";
import { FCC } from "@/types/common";
import { Box, Stack, styled } from "@mui/material";
import { Outlet } from "react-router-dom";

export const AdminLayout: FCC = ({ children }) => {
  const showDrawer = useVisible();

  return (
    <SocketProvider>
      <AppHeader isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
      <Stack width="100%" direction="row">
        <AppDrawer isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
        <ChildrenWrapper onClick={showDrawer.close}>
          <Stack position="relative" height="100%">
            <Outlet />
            {children}
          </Stack>
        </ChildrenWrapper>
      </Stack>
    </SocketProvider>
  );
};

export const AdminLayoutWithAuth = withAuth(AdminLayout);

const ChildrenWrapper = styled(Box)`
  padding: 24px 24px 0;
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  margin: 0 auto;
`;
